import React, { useMemo } from 'react';
import { useParams } from 'react-router-dom';

import { OrganisationOverviewView } from '@futrli/views/OrganisationOverviewView';
import { useApiView } from '@futrli/views/hooks/useApiView';

import { useCurrentUserId } from '../../hooks';
import { PerformanceOverview } from '../performance-overview/performance-overview';

export const PerformanceTabContainer = () => {
  const currentUserId = useCurrentUserId();
  const { workspaceId = '', organisationId = '' } = useParams();

  const view = useApiView(
    useMemo(() => new OrganisationOverviewView(workspaceId, organisationId, currentUserId), [
      workspaceId,
      organisationId,
      currentUserId
    ])
  );

  return <PerformanceOverview view={view} />;
};
